import { render, staticRenderFns } from "./B-3-2-9__BUPageEdit_NewsandEvents.vue?vue&type=template&id=47423fde&"
import script from "./B-3-2-9__BUPageEdit_NewsandEvents.vue?vue&type=script&lang=js&"
export * from "./B-3-2-9__BUPageEdit_NewsandEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VIcon,VMenu,VTextField})
